import { initHolidayArrOnce } from 'utils/common/calendar'
import { getHolidayCalendar } from 'lib/api/service/getHolidayCalendar'

export default function LoadCommonData() {

  // 2025.11.10 공휴일 get & 초기화 함수 추가
  initHolidayArrOnce(getHolidayCalendar).catch((error) => {
    console.error('공휴일 초기화 실패', error)
  })

  return null
}
